export { default as Img200 } from './processed/200/thurston_promo_custom.jpg';
export { default as Img400 } from './processed/400/thurston_promo_custom.jpg';
export { default as Img600 } from './processed/600/thurston_promo_custom.jpg';
export { default as Img800 } from './processed/800/thurston_promo_custom.jpg';
export { default as Img1000 } from './processed/1000/thurston_promo_custom.jpg';
export { default as Imgthumb } from './processed/thumb/thurston_promo_custom.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/thurston_promo_custom.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/thurston_promo_custom.jpg';
export const ImgData = { width: 2074, height: 1032, ratio: 0.49758919961427195, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      196,
      141,
      44
    ],
    "_population": 298,
    "_hsl": [
      0.106359649122807,
      0.6333333333333334,
      0.47058823529411764
    ]
  },
  "LightVibrant": {
    "_rgb": [
      222,
      200,
      147
    ],
    "_population": 379,
    "_hsl": [
      0.11777777777777777,
      0.5319148936170214,
      0.7235294117647059
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      108,
      78,
      24
    ],
    "_population": 0
  },
  "Muted": {
    "_rgb": [
      135,
      135,
      135
    ],
    "_population": 2891,
    "_hsl": [
      0,
      0,
      0.5294117647058824
    ]
  },
  "LightMuted": {
    "_rgb": [
      184,
      184,
      184
    ],
    "_population": 1437,
    "_hsl": [
      0,
      0,
      0.7215686274509804
    ]
  },
  "DarkMuted": {
    "_rgb": [
      68,
      68,
      76
    ],
    "_population": 3,
    "_hsl": [
      0.6666666666666666,
      0.05555555555555555,
      0.2823529411764706
    ]
  }
};



// WEBPACK FOOTER //
// ./src/content/images/thurston_promo_custom.js